import PropTypes from "prop-types";
import React from "react";
import { useSelector } from "react-redux";
import CircularProgress from "@mui/material/CircularProgress";

import { ContainedButton, TextButton } from "common/DS/Buttons";
import { localQuestions } from "redux/questions/selectors";
import COLOR from "lib/colors";

export default function QuestionButtonGroup(
    { handleBack, handleSkip, handleSubmit, nextDisabled, isLastQuestion, forceShowSkip, loading },
    { t: _ },
) {
    const questionCount = useSelector((state) => localQuestions(state).length);
    const isPreview = useSelector((state) => state.is_preview);

    // Only show skip if we have more than 1 question to show
    const showSkip = !!handleSkip && (forceShowSkip || questionCount > 1);
    const showSubmit = !!handleSubmit;
    const showBack = !!handleBack;

    // If we have no buttons, avoid taking up space in the container
    if (!showSkip && !showSubmit) {
        return null;
    }

    return (
        <div className="questions__follow-up-buttons ws-ds-button-container">
            {isPreview && (
                <div className="questions__answers-not-recorded">
                    <span>
                        Answers <strong>NOT</strong> Recorded
                    </span>
                </div>
            )}
            {showBack && (
                <TextButton className="questions__back-btn" size="large" onClick={handleBack}>
                    {_("Back")}
                </TextButton>
            )}
            {showSkip && (
                <TextButton size="large" onClick={handleSkip}>
                    {_("Skip")}
                </TextButton>
            )}
            {showSubmit && (
                <ContainedButton
                    size="large"
                    onClick={handleSubmit}
                    disabled={nextDisabled}
                    data-test="next-button"
                >
                    {loading && (
                        <>
                            <CircularProgress
                                variant="indeterminate"
                                size={10}
                                sx={{ color: COLOR["slate-grey"] }}
                            />
                            &nbsp;
                        </>
                    )}
                    {isLastQuestion ? _("Send") : _("Next")}
                </ContainedButton>
            )}
        </div>
    );
}

QuestionButtonGroup.contextTypes = {
    t: PropTypes.func,
};

QuestionButtonGroup.propTypes = {
    handleBack: PropTypes.func,
    handleSkip: PropTypes.func,
    handleSubmit: PropTypes.func,
    nextDisabled: PropTypes.bool,
    isLastQuestion: PropTypes.bool,
    forceShowSkip: PropTypes.bool,
    loading: PropTypes.bool,
};

QuestionButtonGroup.defaultProps = {
    handleBack: null,
    handleSkip: null,
    handleSubmit: null,
    nextDisabled: false,
    isLastQuestion: false,
    forceShowSkip: false,
    loading: false,
};
